/* eslint-disable @typescript-eslint/no-empty-function */
import type { PropsWithChildren, FC } from 'react';
import { useRef } from 'react';

import { Observed } from '@xing-com/crate-communication-in-view';

import { useNotificationsTracking } from './use-notifications-tracking';

export type NwtTrackingOptionsProps = {
  itemUrn?: string;
  element?: string;
  elementDetail?: string;
};

type Props = {
  onEnter?: () => void;
  nwtTrackingOptions: NwtTrackingOptionsProps;
};

export const InViewTracking: FC<PropsWithChildren<Props>> = ({
  children,
  onEnter,
  nwtTrackingOptions,
}) => {
  const isTrackedRef = useRef(false);
  const { trackNotificationsNWT } = useNotificationsTracking();

  const handleOnEnter = (): void => {
    onEnter?.();

    if (isTrackedRef.current) {
      return;
    }

    trackNotificationsNWT({
      event: 'entered_viewport',
      ...nwtTrackingOptions,
    });
    isTrackedRef.current = true;
  };

  return (
    <>
      {children}
      <Observed onEnter={handleOnEnter} onLeave={() => {}} />
    </>
  );
};
